module.exports = __webpack_public_path__ + "static/media/Mar21-S18.d5b3d73b.png";